export default __webpack_public_path__ + "static/media/menu.8171f907.png";